import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { LicensesService } from 'src/app/services/licenses-service/licenses.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-licenses-licenses-breadcrumb-card',
  templateUrl: './licenses-licenses-breadcrumb-card.component.html',
  styleUrls: ['./licenses-licenses-breadcrumb-card.component.scss']
})
export class LicensesLicensesBreadcrumbCardComponent implements OnInit {

  @Input() licenses;
  @Output() exportLicensesEmitter = new EventEmitter<any>();
  filterOpened: boolean;

  constructor(private userStorageService: UserStorageService,
              private licensesService: LicensesService) { }

  ngOnInit() {
    if (this.userStorageService.getFilterLicenses()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public search(event) {
    this.licensesService.searchLicenses(event.target.value);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public exportLicensesList() {
    this.exportLicensesEmitter.emit();
  }
}
